/** Sous-rôles internes Gisgo Ops (extension de UserRoleType côté API). */
export type StaffRole = 'dispatcher' | 'sales' | 'admin';

export interface StaffUser {
  readonly id: number;
  readonly name: string;
  readonly email: string;
  readonly role: StaffRole;
}

export const STAFF_ROLE_LABELS: Record<StaffRole, string> = {
  dispatcher: 'Dispatcher',
  sales: 'Commercial',
  admin: 'Admin',
};
